<template>
  <v-container class="triggers-queue" fluid>
    <v-card>
      <v-card-title>
        <v-row justify="start" no-gutters>
          <span class="card-title px-0 mt-3 mr-1 mb-4">Fila de disparo do número</span>
          <v-col cols="auto">
            <v-tooltip top max-width="225px">
              <template v-slot:activator="{ on }">
                <div v-on="numbers.length > 0 ? on : ''">
                  <v-select
                    v-model="numberSelect"
                    :disabled="numbers.length <= 0"
                    class="mb-4"
                    :items="numbers"
                    hide-details
                    item-value="val"
                    item-text="text"
                    @change="getChartData()"
                  />
                </div>
              </template>
              <span>Clique para ver a fila de disparos de outro número</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle>
        <p class="texto-corrido">
          Nesse gráfico você pode ver, por número, quantos disparos estão agendados e acompanhar o andamento disso. Você também pode ver as campanhas que
          compõem essa fila de disparos.
        </p>
      </v-card-subtitle>
      <v-card-text>
        <v-row v-if="chartLoader" justify="center" style="height: 265px">
          <v-col cols="1" style="padding-top: 100px">
            <v-progress-circular size="60" indeterminate color="primary" />
          </v-col>
        </v-row>
        <v-row v-else-if="voidChart" justify="center" style="height: 265px">
          <v-col class="texto-corrido text-center" cols="4" style="padding-top: 100px">
            Nenhuma campanha está sendo disparada nessa combinação de período e disparador, selecione outro período ou entre em contato com o suporte pelo chat
          </v-col>
        </v-row>
        <apexchart v-else type="bar" height="250" :options="chartOptions" :series="series" @dataPointSelection="openCampaignDetails" />
        <v-row no-gutters>
          <v-spacer />
          <mf-tooltip top max-width="192px">
            <template #activator="{ on }">
              <mf-button type="icon" icon="arrow_left" size="sm" color="cinza-0" @click="changeDate(-1)" />
            </template>
            <span>Dia anterior</span>
          </mf-tooltip>
          <span class="date-selected mt-1">{{ DateTime.fromFormat(dateSelected, 'yyyy-MM-dd').setLocale('pt-BR').toFormat("d 'de' MMMM, yyyy") }}</span>
          <mf-tooltip top max-width="192px">
            <template #activator="{ on }">
              <mf-button
                :disabled="DateTime.now().toFormat('yyyy-MM-dd') === dateSelected"
                type="icon"
                icon="arrow_right"
                size="sm"
                color="cinza-0"
                @click="changeDate(1)"
              />
            </template>
            <span>Próximo dia</span>
          </mf-tooltip>
        </v-row>
        <v-dialog v-model="dialog" max-width="800px" scrollable>
          <v-card class="pa-2">
            <v-card-title class="pl-3" align-content-start>
              <div fluid grid-list-xl>
                <p class="title mb-0">{{ details[activeIndex] ? details[activeIndex].title : '' }}</p>
                <p class="subtitle">Fila de disparos do número {{ numberSelectedInfo }}</p>
              </div>
              <v-spacer />
              <div>
                <mf-tooltip top max-width="192px">
                  <template #activator="{ on }">
                    <mf-button type="icon" icon="arrow_left" size="sm" color="cinza-0" @click="changeDate(-1)" />
                  </template>
                  <span>Dia anterior</span>
                </mf-tooltip>
                <mf-tooltip top max-width="192px">
                  <template #activator="{ on }">
                    <mf-button type="icon" icon="arrow_left" size="sm" :disabled="activeIndex === 0" color="cinza-0" @click="activeIndex = activeIndex - 1" />
                  </template>
                  <span>Hora anterior</span>
                </mf-tooltip>
                <mf-tooltip top max-width="192px">
                  <template #activator="{ on }">
                    <mf-button
                      type="icon"
                      icon="keyboard_arrow_right"
                      size="sm"
                      :disabled="activeIndex >= timeLabels.length - 1"
                      color="cinza-0"
                      @click="activeIndex = activeIndex + 1"
                    />
                  </template>
                  <span>Próxima hora</span>
                </mf-tooltip>
                <mf-tooltip top max-width="192px">
                  <template #activator="{ on }">
                    <mf-button
                      type="icon"
                      icon="arrow_right"
                      size="sm"
                      :disabled="DateTime.now().toFormat('yyyy-MM-dd') === dateSelected"
                      color="cinza-0"
                      @click="changeDate(1)"
                    />
                  </template>
                  <span>Próximo dia</span>
                </mf-tooltip>
              </div>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table :headers="headers" :items="details[activeIndex] ? details[activeIndex].senders : []" :loading="chartLoader" hide-default-footer>
                <template v-slot:item="{ item }">
                  <tr v-if="item.name !== 'Total'">
                    <td class="nowrap-row">
                      <v-tooltip v-if="item.name.length > 24" max-width="250" top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on"
                            ><a class="link" :href="link(item._id, item.status)" target="_blank">{{ getFormatedText(item.name) }}</a></span
                          >
                        </template>
                        <span>{{ item.name }}</span>
                      </v-tooltip>
                      <span v-else>
                        <a class="link" :href="link(item._id, item.status)" target="_blank">{{ item.name }}</a>
                      </span>
                    </td>
                    <td>{{ item.total }}</td>
                    <td>
                      {{ item.accumulated }} <span class="tax">{{ getTax(item.accumulated, item.total) }}%</span>
                    </td>
                    <td>{{ item.partial }}</td>
                  </tr>
                </template>
                <template v-if="series.length > 1 && totalResume" v-slot:body.append>
                  <tr>
                    <td class="td-total">Total</td>
                    <td class="td-total">{{ totalResume.total }}</td>
                    <td class="td-total">
                      {{ totalResume.accumulated }} <span class="tax">{{ getTax(totalResume.accumulated, totalResume.total) }}%</span>
                    </td>
                    <td class="td-total">{{ totalResume.partial }}</td>
                  </tr>
                </template>
              </v-data-table>
              <mf-action-buttons
                class="mt-2"
                :primary-button="{
                  text: 'Fechar',
                  action: () => (dialog = false),
                  isVisible: true,
                }"
              />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import gql from 'graphql-tag'
import { DateTime } from 'luxon'
import truncate from 'lodash/truncate'

const SENDER_MESSAGE_ACTIVITY = gql`
  query SenderMessagesQueues($sender: String!, $date: String!) {
    senderMessagesQueues(sender: $sender, date: $date) {
      time
      queues {
        campaign {
          _id
          title
          status
        }
        quantity
      }
    }
  }
`

const QUERY_GET_NUMBERS = gql`
  query GetNumbers {
    getNumbers(type: SENDER) {
      _id
      name
      number
    }
  }
`

export default {
  name: 'TriggersQueueChart',
  data: () => ({
    DateTime: DateTime,
    timeout: {},
    chartLoader: false,
    dialog: false,
    activeIndex: 0,
    dateSelected: '',
    details: [],
    timeLabels: [],
    numbers: [],
    numberSelect: '',
    series: [],
    voidChart: false,
    chartOptions: {
      colors: ['#00B395', '#002040', '#D4FF00', '#2252B2', '#FECA55', '#D24A43', '#00A186', '#001D3A'],
      chart: {
        type: 'bar',
        height: 250,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: false,
        },
        animations: {
          enabled: false,
        },
        events: {
          dataPointMouseEnter: function (event) {
            event.path[0].style.cursor = 'pointer'
          },
        },
      },
      tooltip: {
        custom: function () {
          return '<div><span class="apex-tooltip">Clique para ver mais detalhes</span></div>'
        },
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 3,
          horizontal: false,
          columnWidth: '17px',
          dataLabels: {
            position: 'top',
            hideOverflowingLabels: false,
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#304758'],
        },
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          let lastIdxWithValue = true
          w.config.series.forEach((item, idx) => {
            if (idx > seriesIndex && item.data[dataPointIndex].y > 0) {
              lastIdxWithValue = false
            }
          })
          if (seriesIndex === w.config.series.length - parseInt(1) || lastIdxWithValue) {
            return w.globals.stackedSeriesTotals[dataPointIndex]
          }
          return ''
        },
      },
      fill: {
        opacity: 1,
      },
      markers: {
        size: 0,
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeUTC: false,
        },
      },
      states: {
        hover: {
          filter: {
            type: 'none',
          },
        },
        active: {
          filter: {
            type: 'none',
          },
        },
      },
    },
  }),
  computed: {
    totalResume() {
      const lastIndex = this.details[this.activeIndex]?.senders.length - 1
      return this.details[this.activeIndex]?.senders[lastIndex]
    },
    numberSelectedInfo() {
      const number = this.numbers.filter((number) => number.val === this.numberSelect)[0]
      return number ? number.text : ''
    },
    headers() {
      return [
        {
          text: 'Campanha',
          value: 'name',
          width: '35%',
        },
        {
          text: 'Total de disparos',
          value: 'total',
          width: '20%',
        },
        {
          text: 'Total acumulado',
          value: 'accumulated',
          width: '25%',
        },
        {
          text: 'Nesta hora',
          value: 'partial',
          width: '20%',
        },
      ]
    },
  },
  apollo: {
    numbers: {
      query: QUERY_GET_NUMBERS,
      update({ getNumbers }) {
        const numbers = getNumbers.map((number) => {
          return {
            text: number.name === number.number ? phoneNumberFormat(number.number) : `${number.name} ${phoneNumberFormat(number.number)}`,
            val: number.number,
          }
        })
        this.dateSelected = DateTime.now().toFormat('yyyy-MM-dd')
        if (numbers[0]) {
          this.numberSelect = numbers[0].val
          this.getChartData()
        } else {
          this.voidChart = true
        }
        return numbers
      },
    },
  },
  methods: {
    link(param, status) {
      if (status === 'DRAFT' || status === 'SCHEDULED') return `#/campanhas/whatsapp/editar/${param}`
      else if (status === 'FINISHED' || status === 'ACTIVE') return `#/campanhas/whatsapp/resultados/${param}`
    },
    getFormatedText(text) {
      return truncate(text, {
        length: 35,
        separator: ' ',
      })
    },
    getTax(acc, total) {
      if (acc / total) return Math.round((acc / total) * 100)
      return 0
    },
    changeDate(day) {
      if (day === 1 && DateTime.now().toFormat('yyyy-MM-dd') === this.dateSelected) return
      this.dateSelected = DateTime.fromFormat(this.dateSelected, 'yyyy-MM-dd').plus({ days: day }).toFormat('yyyy-MM-dd')
      clearTimeout(this.timeout)
      this.chartLoader = true
      this.timeout = setTimeout(() => {
        this.getChartData()
      }, 1000)
    },
    openCampaignDetails(event, chartContext, config) {
      this.activeIndex = config.dataPointIndex
      this.dialog = true
    },
    async getChartData() {
      this.chartLoader = true
      const series = []
      this.details = []
      try {
        const { data: senderActivity } = await this.$apollo.query({
          query: SENDER_MESSAGE_ACTIVITY,
          variables: {
            sender: this.numberSelect,
            date: this.dateSelected,
          },
        })
        this.timeLabels = []
        senderActivity.senderMessagesQueues.forEach((item) => {
          this.timeLabels.push(item.time)
          item.queues.forEach((queue) => {
            if (series.map((serie) => serie._id).includes(queue.campaign._id)) {
              const indexSerie = series.findIndex((item) => item._id === queue.campaign._id)
              series[indexSerie].data.push({ x: DateTime.fromFormat(`${this.dateSelected} ${item.time}`, 'yyyy-MM-dd HH:mm').ts, y: queue.quantity })
            } else {
              series.push({
                _id: queue.campaign._id,
                name: queue.campaign.title,
                status: queue.campaign.status,
                type: 'column',
                data: [{ x: DateTime.fromFormat(`${this.dateSelected} ${item.time}`, 'yyyy-MM-dd HH:mm').ts, y: queue.quantity }],
              })
            }
          })
        })
        this.voidChart = false
      } catch (e) {
        this.voidChart = true
        this.chartLoader = false
        return
      }
      this.series = series.map((serie) => {
        const { _id, status, ...rest } = serie
        return rest
      })
      this.chartLoader = false
      const senders = []
      this.timeLabels.forEach((time, timeIdx) => {
        const dayLabel = DateTime.fromFormat(`${this.dateSelected} ${time}`, 'yyyy-MM-dd HH:mm')
          .setLocale('pt-BR')
          .toFormat("'Dia' d 'de' MMMM 'de' yyyy - HH'h'")
        const data = series.map((item) => {
          let max = Math.max(...item.data.map((info, dataIndex) => (dataIndex <= timeIdx ? info.y : 0)))
          let diff = item.data[timeIdx - 1] && item.data[timeIdx - 1].y !== 0 ? item.data[timeIdx - 1].y - item.data[timeIdx].y : 0
          return {
            name: item.name,
            _id: item._id,
            status: item.status,
            partial: diff,
            total: max,
          }
        })

        if (series.length > 1) {
          const resume = data.reduce((acc, curr) => {
            return {
              total: acc.total + curr.total,
              partial: acc.partial + curr.partial,
            }
          })

          data.push({
            name: 'Total',
            partial: resume.partial,
            total: resume.total,
          })
        }
        senders.push(data)

        this.details.push({
          title: dayLabel,
          senders: senders[timeIdx],
        })
      })

      for (let [key, value] of Object.entries(this.details)) {
        value.senders.map((item, index) => {
          item.accumulated =
            key > 0
              ? this.details[parseInt(key) - 1].senders[index].accumulated + this.details[key].senders[index].partial
              : this.details[key].senders[index].partial
          return item
        })
      }
    },
  },
}
</script>
<style lang="scss">
.triggers-queue {
  .date-selected {
    @extend .table-card-title-whats !optional;
    padding: 0 4px;
  }
  .subtitle {
    display: block;
  }
  .apex-tooltip {
    background: rgba(97, 97, 97, 0.9);
    color: $branco;
    border-radius: 4px;
    font-size: 14px;
    line-height: 22px;
    display: inline-block;
    padding: 5px 16px;
    text-transform: none;
    width: auto;
    opacity: 1;
    pointer-events: none;
  }

  .td-total {
    width: 25%;
  }

  .v-select {
    padding-top: 1px !important;
  }

  .v-select__selections input {
    width: 50px;
  }

  .v-select__selection {
    color: $marca-0-l40 !important;
  }
}
.tax {
  color: $cinza-l20;
}
</style>
